import { render, staticRenderFns } from "./CreateBill.vue?vue&type=template&id=1304631e&"
import script from "./CreateBill.vue?vue&type=script&lang=js&"
export * from "./CreateBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports